// extracted by mini-css-extract-plugin
export default {"label":"TreeNodeLabel__label--1pp8L"};